/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lg-container[_ngcontent-%COMP%]{padding:1rem;display:grid;align-items:stretch}.top-border[_ngcontent-%COMP%]{border-top:1px solid rgba(120,130,140,.13)}"];
export { styles as styles };
